module.exports = "<p>\n  users works!\n</p>\n"